export const AlphaGlyphFull = () => (
    <>
        <path
            d="M8.24822 7.24756C6.37046 7.24756 4.84766 9.28588 4.84766 11.8001C4.84766 14.3144 6.36974 16.3527 8.24822 16.3527C10.1267 16.3527 11.6488 14.3144 11.6488 11.8001C11.6488 9.28588 10.1267 7.24756 8.24822 7.24756ZM8.40446 14.544C7.51958 14.544 6.80246 13.3172 6.80246 11.8037C6.80246 10.2903 7.51958 9.0634 8.40446 9.0634C9.28934 9.0634 10.0065 10.2903 10.0065 11.8037C10.0065 13.3172 9.28934 14.544 8.40446 14.544Z"
            fill="#179C5F"
        />
        <path
            d="M14.0856 14.6102L12.5678 11.7993L14.0856 8.98844C14.3426 8.51252 14.1648 7.91852 13.6896 7.6622C13.2136 7.40516 12.6204 7.583 12.3633 8.0582L11.2819 10.0605L10.9968 9.37004L10.0586 9.85604L10.343 11.7986L10.3099 13.2062L11.1645 13.3653L11.2696 13.5144L12.3633 15.5397C12.6204 16.0156 13.2144 16.1928 13.6896 15.9357C14.1655 15.6787 14.3426 15.0847 14.0856 14.6095V14.6102Z"
            fill="#179C5F"
        />
    </>
);

export const AlphaPlusFull = () => (
    <path d="M15.8229 11.1744V9.45215H17.1384V11.1744H18.7562V12.4236H17.1384V14.1552H15.8229V12.4236H14.2051V11.1744H15.8229Z" fill="#179C5F" />
);

export const AlphaGlyphMinimized = () => (
    <>
        <path
            d="M3.54475 2.57385C1.71915 2.57385 0.238647 4.55555 0.238647 6.99995C0.238647 9.44435 1.71845 11.4261 3.54475 11.4261C5.37105 11.4261 6.85085 9.44435 6.85085 6.99995C6.85085 4.55555 5.37105 2.57385 3.54475 2.57385ZM3.69665 9.66765C2.83635 9.66765 2.13915 8.47485 2.13915 7.00345C2.13915 5.53205 2.83635 4.33925 3.69665 4.33925C4.55695 4.33925 5.25415 5.53205 5.25415 7.00345C5.25415 8.47485 4.55695 9.66765 3.69665 9.66765Z"
            fill="#179C5F"
        />
        <path
            d="M9.22113 9.73211L7.74553 6.99931L9.22113 4.26651C9.47103 3.80381 9.29813 3.22631 8.83613 2.97711C8.37343 2.72721 7.79663 2.90011 7.54673 3.36211L6.49533 5.30881L6.21813 4.63751L5.30603 5.11001L5.58253 6.99861L5.55033 8.36711L6.38123 8.52181L6.48343 8.66671L7.54673 10.6358C7.79663 11.0985 8.37413 11.2707 8.83613 11.0208C9.29883 10.7709 9.47103 10.1934 9.22113 9.73141V9.73211Z"
            fill="#179C5F"
        />
    </>
);

export const AlphaPlusMinimized = () => (
    <path d="M10.9088 6.39169V4.71729H12.1877V6.39169H13.7606V7.60619H12.1877V9.28969H10.9088V7.60619H9.33594V6.39169H10.9088Z" fill="#179C5F" />
);
